import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuetify from 'vuetify'

// import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import HttpService from './Http.js'
import VueI18n from 'vue-i18n'
import messages from './assets/messages.json'
import VueNoty from 'vuejs-noty'
import 'vuetify/dist/vuetify.min.css'
import 'vue-cal/dist/vuecal.css'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueApexCharts from 'vue-apexcharts'
import * as Icons from 'vue-feather-icons'

// Leaflet Map
import { LMap, LTileLayer, LMarker, LPolygon, LCircle } from 'vue2-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';


// WYSIWYG Editor
import { VueEditor } from "vue2-editor";

// Vue Components
import ResetPassword from './components/ResetPassword.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import Users from './components/Users.vue'
import Tenants from './components/Tenants.vue'
import TargetGroups from './components/TargetGroups.vue'
import Placements from './components/Placements.vue'
import PlacementTypes from './components/PlacementTypes.vue'
import Advertisements from './components/Advertisements.vue'
import Apps from './components/Apps.vue'
import AppSpecificData from './components/AppSpecificData.vue'
import Purchases from './components/Purchases.vue'
import Roles from './components/Roles.vue'
import Login from './components/Login.vue'
import Register from './components/Register.vue'
import CreateTenant from './components/CreateTenant.vue'
import CreateTargetGroup from './components/CreateTargetGroup.vue'
import CreateApp from './components/CreateApp.vue'
import CreateAppSpecificData from './components/CreateAppSpecificData.vue'
import CreateAdvertisement from './components/CreateAdvertisement.vue'
import CreatePlacement from './components/CreatePlacement.vue'
import CreatePlacementType from './components/CreatePlacementType.vue'
import CreateExpertBenefit from './components/CreateExpertBenefit.vue'
import CreateUser from './components/CreateUser.vue'
import Benefits from './components/Benefits.vue'

import Dashboard from './components/Dashboard.vue'

// Widgets
import Contact from "./components/widget/Contact.vue"
import Share from "./components/widget/Share.vue"
import Upload from "./components/widget/Upload.vue"
import UploadToS3 from "./components/widget/UploadToS3.vue"
import LanguagePicker from "./components/widget/LanguagePicker.vue"
import DatePicker from "./components/widget/DatePicker.vue"
import AppIconCheck from "./components/widget/AppIconCheck.vue"
import AppIconList from "./components/widget/AppIconList.vue"
import AdvertisementSelect from "./components/widget/AdvertisementSelect.vue"
import FilterForm from "./components/widget/FilterForm.vue"



// Main Page
import App from './views/App.vue'

Vue.config.productionTip = false;

// Global Access Variables
Vue.prototype.$axios = HttpService;     // axios
Vue.prototype.$rights = [];             // User rights
Vue.prototype.$external = true;             // User rights
Vue.prototype.$languages = [];         // Function for finding flag by language String, e.g. GERMAN
Vue.prototype.$bucket = 'adnetwork-production-bucket';
Vue.prototype.$accessKeyId = 'AKIA4JSAEVWJZ4XTN7AE';
Vue.prototype.$secretAccessKey = 'VzG4nJMgOy5WO5DXHaDQdEEjckhN5Br78NNmTNuO';


window.Vue = Vue;

// Use base Components
Vue.use(Vuetify)
Vue.use(VueRouter)
Vue.use(VueEditor, /* { default global options} */)
Vue.component("vue-editor", VueEditor);
// Vue.use(BootstrapVue)

// Components
Vue.use(ResetPassword)
Vue.use(Users)
// Vue.use(Cases)
Vue.use(Tenants)
Vue.use(TargetGroups)
Vue.use(Placements)
Vue.use(PlacementTypes)
Vue.use(Advertisements)
Vue.use(Apps)
Vue.use(AppSpecificData)
Vue.use(Purchases)
Vue.use(Login)
Vue.use(Register)
Vue.use(ResetPassword)

// Widgets
Vue.use(Contact)
Vue.component("Contact", Contact);
Vue.use(Share)
Vue.component("Share", Share);
Vue.use(Upload)
Vue.component("Upload", Upload);
Vue.use(UploadToS3)
Vue.component("UploadToS3", UploadToS3);
Vue.use(LanguagePicker)
Vue.component("LanguagePicker", LanguagePicker);
Vue.use(DatePicker)
Vue.component("DatePicker", DatePicker);
Vue.use(AppIconCheck)
Vue.component("AppIconCheck", AppIconCheck);
Vue.use(AppIconList)
Vue.component("AppIconList", AppIconList);
Vue.use(AdvertisementSelect)
Vue.component("AdvertisementSelect", AdvertisementSelect);
Vue.use(FilterForm)
Vue.component("FilterForm", FilterForm);

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// Leaflet for OpenRouteService Map
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-polygon', LPolygon);
Vue.component('l-circle',LCircle)

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
   iconUrl: require('leaflet/dist/images/marker-icon.png'),
   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Language
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'de',
    messages,
});

console.log(window.themeColors);

// Vuetify
const vuetifyOpts = {
    theme: {
        themes: {
            light: {
                primary: "#2F3452",
                secondary: "#003A61",
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FB8C00",
                grey: "#2f2f2f",
            }
        }
    },
};

if(window.themeColors){
    vuetifyOpts.theme.themes.light = JSON.parse(window.themeColors);
}
Vue.prototype.$adnetworkTheme = window.theme;

const vuetify = new Vuetify(vuetifyOpts);


// Vue Router
const router = new VueRouter({
    routes: [
        // {
        //     path: "/", component: Login
        // },
        { path: "/login", component: Login, props: route => ({ routingTarget: route.query.routingTarget }) },
        { path: "/register", component: Register },
        { path: "/dashboard", component: Dashboard },
        { path: "/users", component: Users },
        { path: "/tenants", component: Tenants },
        { path: "/targetgroups", component: TargetGroups },
        { path: "/placements", component: Placements },
        { path: "/placementtypes", component: PlacementTypes },
        { path: "/advertisements", component: Advertisements },
        { path: "/apps", component: Apps },
        { path: "/appspecifics", component: AppSpecificData },
        { path: "/purchases", component: Purchases },
        { path: "/roles", component: Roles },
        { path: "/create-placement", component: CreatePlacement },
        { path: "/edit-placement", component: CreatePlacement, props: route => ({ placementId: route.query.placementId }) },
        { path: "/create-placementType", component: CreatePlacementType },
        { path: "/edit-placementType", component: CreatePlacementType, props: route => ({ placementTypeId: route.query.placementTypeId }) },
        { path: "/create-advertisement", component: CreateAdvertisement },
        { path: "/edit-advertisement", component: CreateAdvertisement, props: route => ({ advertisementId: route.query.advertisementId }) },
        { path: "/create-targetgroup", component: CreateTargetGroup },
        { path: "/edit-targetgroup", component: CreateTargetGroup, props: route => ({ targetgroupId: route.query.targetgroupId }) },
        { path: "/create-app", component: CreateApp },
        { path: "/edit-app", component: CreateApp, props: route => ({ appId: route.query.appId }) },
        { path: "/create-appspecifics", component: CreateAppSpecificData },
        { path: "/edit-appspecifics", component: CreateAppSpecificData, props: route => ({ appspecificdataId: route.query.appspecificdataId }) },
        { path: "/create-tenant", component: CreateTenant },
        { path: "/edit-tenant", component: CreateTenant, props: route => ({ tenantId: route.query.tenantId }) },
        { path: "/create-user", component: CreateUser },
        { path: "/edit-user", component: CreateUser, props: route => ({ userId: route.query.userId }) },
        { path: "/forgot-password", component: ForgotPassword },
        { path: "/reset-password", component: ResetPassword, props: route => ({ token: route.query.token }) },
        { path: "/benefits", component: Benefits },
        { path: "/create-benefit", component: CreateExpertBenefit },
        { path: "/edit-benefit", component: CreateExpertBenefit, props: route => ({ expertBenefitId: route.query.expertBenefitId }) },
    ],
    mode: "history"
});

Object.defineProperty(Vue.prototype, '$locale', {
    get: function () {
        return i18n.locale
    },
    set: function (locale) {
        i18n.locale = locale
    }
});


// Notifications
Vue.use(VueNoty, {
    timeout: 6000,
    progressBar: true,
    killer: true,
    layout: 'topRight'
});

// Global Methods
Vue.prototype.$formatDate = function(dateStr){
    return new Date(dateStr).toLocaleDateString(navigator.languages, { year: 'numeric', month: '2-digit', day: '2-digit' });
}

Vue.prototype.$formatDateTime = function(dateStr){
    return new Date(dateStr).toLocaleDateString(navigator.languages, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
}

Vue.prototype.$formatCurrency = function(val){
    if(val == null) val = 0;
    return val.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

Vue.prototype.$finalize = function(){
    progressIndicator.hidden = true;
}

Vue.prototype.$routerPush = function(path, right, elsePath = null){
    if(this.$rights.includes(right)){
        this.$router.push(path);
    }else if(elsePath != null){
        this.$router.push(elsePath);
    }
}

Vue.prototype.$routerBack = function(){
    this.$router.go(-1);
}

Vue.prototype.$reloadUser = function(){
    var _this = this;
    this.$axios.get("/api/user/me").then(function(response){
        const user = response.data;
        Vue.prototype.$user = Vue.observable({ data: user, setValue(val) {this.data = val;}, getValue() {return this.data;}});
        Vue.prototype.$rights = user.allRights;
        _this.$forceUpdate();
    })
}

new Vue({
    render: h => h(App),
    components: { App, Contact, Share, LMap, LTileLayer, LMarker, LPolygon,LCircle },
    i18n,
    router,
    vuetify,
    watch:{
        $route (to, from){
            window.scrollTo(0, 0);
        }
    },
    beforeCreate: function(){
        if(window.location.href.includes("?lang")){
            window.location.href = window.location.href.substring(0, window.location.href.indexOf("?"));
        }
        if(window.location.href.includes("%3Flang")){
            window.location.href = window.location.href.substring(0, window.location.href.indexOf("%3Flang"));
        }
    },
    beforeMount: function () {
        var _this = this; 
        this.$axios.get("/api/user/me").then(function(response){
            const user = response.data;
            Vue.prototype.$user = Vue.observable({ data: user, setValue(val) {this.data = val;}, getValue() {return this.data;}});
            Vue.prototype.$rights = user.allRights;
            const routingTarget = user.allRights.includes("VIEW_DASHBOARD") ? "/dashboard" : user.allRights.includes("MANAGE_ADVERTISEMENTS") ? "/advertisements" : "/users";
            _this.checkWindowLocationAndRouteToLogin(true, routingTarget);
            _this.$forceUpdate();
        })
        .catch(function(error){
            console.error(error);

            _this.checkWindowLocationAndRouteToLogin(false);
        });

        this.$axios.get("/api/language/me").then(function(response){ 
            var selectedlanguage = response.data.shortForm;
            Vue.prototype.$language = selectedlanguage;
            _this.$locale = selectedlanguage.toLowerCase();
        }).catch(function(error){
            console.error(error);
        });

        this.$axios.get("/api/language/all").then(function(response){ 
            Vue.prototype.$languages = response.data;
            const languages = response.data;
            const lnlist = [];
            for (var i in languages){
                var language = {
                    key: languages[i].language,
                    name: _this.$t(languages[i].language),
                    flag: languages[i].flag,
                    shortForm: languages[i].shortForm
                };
                lnlist.push(language);
            }
            Vue.prototype.$selectableLanguages = lnlist;
        }).catch(function(error){
            console.error(error);
        });
    },
    methods: {
        setUser(user) {
            this.user = user;
        },

        checkWindowLocationAndRouteToLogin(loggedIn = false, routingTarget = "/dashboard"){
            var location = window.location.href;
            if(location.startsWith("http://") || location.startsWith("https://")) location = location.substring(location.indexOf("//") + 2);
            console.log(location);
            const unauthRoutes = ["/login", "/forgot-password", "/reset-password","/register"];
            const authRoutes = [];

            const allowedRoutes = loggedIn ? authRoutes : unauthRoutes;
            const unallowedRoutes = loggedIn ? unauthRoutes : authRoutes;
            
            var routeAllowed = loggedIn ? true : false;

            // Check allowedRoutes
            for (let i = 0; i < allowedRoutes.length; i++) {
                const allowedRoute = allowedRoutes[i];
                if(location.includes(allowedRoute)){
                    routeAllowed = true;
                    break;
                }
            }

            // Check unallowedRoutes
            for (let i = 0; i < unallowedRoutes.length; i++) {
                const unallowedRoute = unallowedRoutes[i];
                if(location.includes(unallowedRoute)){
                    routeAllowed = false;
                    break;
                }
            }
            if(!location.includes("/")) return; // Start Page always allowed
            if(routeAllowed) return;

            const unallowedRoute = location.substring(location.indexOf("/"));
            if(unallowedRoute == "/") return; // Start Page always allowed

            console.log(unallowedRoute);
            if(loggedIn){
                this.$router.push(routingTarget);
            }else{
                this.$router.push("/login?routingTarget=" + unallowedRoute);
            }
        },
    }
}).$mount("#app");
